import { withTokensIfNeeded } from 'common/api/utils/withTokensIfNeeded';
import { E_COMM_PRODUCTS_URL } from 'common/api/config';

export interface StateRebateAdjustment {
    adjustment: number;
}

export const getStateRebateAdjustment = (state: string) =>
    withTokensIfNeeded<StateRebateAdjustment>(`${E_COMM_PRODUCTS_URL}/rebate/${state}`);
